import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#25479A",
        },
    },
    components: {
        MuiCheckbox: {
            defaultProps: {
                style: {
                    padding: 0,
                },
            },
        },
        MuiRadio: {
            defaultProps: {
                style: {
                    padding: 0,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                style: {
                    height: "20px",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                },
            },
        },
    },
});

export default function MaterialThemeProvider({ children }: IMaterialThemeProviderProps) {
    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    )
}

interface IMaterialThemeProviderProps {
    children: React.ReactNode;
}